import { Button, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Timer from "./Timer";

// icons
import SkipNextIcon from "@mui/icons-material/SkipNext";
import StopIcon from "@mui/icons-material/Stop";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

function RandomPoseControls({
  closeHandler,
  isThereAnImage,
  sessionType,
  timer,
  timerPlaying,
  timeLimit,
  actualRefreshImg,
  theme,
  isLandscape,
  togglePauseSession,
  pauseClicked,
  isLoading
}) {
  return (
    <>
      {isThereAnImage ? (
        <Box textAlign="center" sx={{ padding: 2 }}>
          {sessionType === "timed" ? (
            <Box sx={{ mb: 2 }}>
              <Box sx={{ width: "100px", margin: "auto", mb: 2 }}>
                <Timer
                  key={timer}
                  isPlaying={timerPlaying}
                  timeLimit={timeLimit}
                  refreshImg={actualRefreshImg}
                  theme={theme}
                ></Timer>
              </Box>
            </Box>
          ) : null}

          <Stack
            direction={isLandscape ? "column" : "row"}
            spacing={2}
            justifyContent="center"
          >
            {sessionType === "timed" ? (
              <Button
                disabled={isLoading}
                variant="outlined"
                disableElevation
                color="primary"
                onClick={togglePauseSession}
              >
                {pauseClicked ? <PlayArrowIcon /> : <PauseIcon />}
              </Button>
            ) : (
              ""
            )}

            <Button
                disabled={isLoading}
              variant="outlined"
              disableElevation
              color="primary"
              onClick={actualRefreshImg}
            >
              <SkipNextIcon />
            </Button>

            <Button variant="outlined" disableElevation onClick={closeHandler}>
              <StopIcon />
            </Button>
          </Stack>
        </Box>
      ) : (
        ""
      )}
    </>
  );
}

export default RandomPoseControls;
